function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var saito = require('../../lib/saito/saito');
var ModTemplate = require('../../lib/templates/modtemplate');
var KeyEntry = require('./../../lib/saito/ui/modals/saito-recovery/saito-recovery');
var SaitoLogin = require('./lib/login');
var SaitoBackup = require('./lib/backup');
var Transaction = require('../../lib/saito/transaction')["default"];
var PeerService = require('saito-js/lib/peer_service')["default"];
var Recovery = /*#__PURE__*/function (_ModTemplate) {
  function Recovery(app) {
    var _this;
    _classCallCheck(this, Recovery);
    _this = _callSuper(this, Recovery, [app]);
    _this.name = 'Recovery';
    _this.slug = 'recovery';
    _this.description = 'Secure wallet backup and recovery';
    _this.categories = 'Utilities Core';
    _this["class"] = 'utility';
    _this.status = 'prod';
    _this.styles = ['/recovery/style.css'];
    _this.backup_overlay = new SaitoBackup(app, _this);
    _this.login_overlay = new SaitoLogin(app, _this);
    _this.key_entry = new KeyEntry(app, _this);
    _this.keychain_hash = '';
    app.connection.on('recovery-backup-overlay-render-request', /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(obj) {
        var key;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              console.debug('Received recovery-backup-overlay-render-request');

              //
              // Otherwise, call up the modal to query them from the user
              //

              if (obj !== null && obj !== void 0 && obj.success_callback) {
                _this.backup_overlay.success_callback = obj.success_callback;
              }

              //
              // if we already have the email/password, just send the backup
              //
              key = app.keychain.returnKey(_this.publicKey);
              if (!key) {
                _context.n = 2;
                break;
              }
              if (!(key.email && key.wallet_decryption_secret && key.wallet_retrieval_hash)) {
                _context.n = 2;
                break;
              }
              siteMessage('backing up wallet...', 10000);
              _context.n = 1;
              return _this.backupWallet({
                email: key.email,
                decryption_secret: key.wallet_decryption_secret,
                retrieval_hash: key.wallet_retrieval_hash
              });
            case 1:
              _this.app.wallet.saveWallet();
              _this.app.connection.emit('saito-header-update-message');
              return _context.a(2);
            case 2:
              _this.backup_overlay.render();
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    return _this;
  }
  _inherits(Recovery, _ModTemplate);
  return _createClass(Recovery, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(app) {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _superPropGet(Recovery, "initialize", this, 3)([app]);
            case 1:
              if (app.BROWSER) {
                this.attachStyleSheets();
              }

              /// Clean up detritus in the wallet
              if (this.app.options.wallet) {
                delete this.app.options.wallet.account_recovery_hash;
                delete this.app.options.wallet.account_recovery_secret;
                delete this.app.options.wallet.backup_required_msg;
                this.app.storage.saveOptions();
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function initialize(_x2) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "onPeerServiceUp",
    value: function () {
      var _onPeerServiceUp = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(app, peer) {
        var service,
          _this$app$options$wal,
          now,
          _args3 = arguments;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              service = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : {};
              if (app.BROWSER) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              if (service.service === 'relay') {
                now = Date.now(); //
                // If a "clean" wallet or been at least an hour, check if we have a backup saved remotely
                //
                if (!((_this$app$options$wal = this.app.options.wallet) !== null && _this$app$options$wal !== void 0 && _this$app$options$wal.ts) || now - this.app.options.wallet.ts > 360000) {
                  // send a peer request to see if our public key is in recovery database
                  // attempt to decrypt
                  // prompt user to swap out wallet
                  // ... but ...
                  // if we are catching up on blocks in the mean time...
                  // ... we might get unexpected results ...
                }
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function onPeerServiceUp(_x3, _x4) {
        return _onPeerServiceUp.apply(this, arguments);
      }
      return onPeerServiceUp;
    }()
  }, {
    key: "returnDecryptionSecret",
    value: function returnDecryptionSecret() {
      var email = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var pass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var hash1 = 'WHENINDISGRACEWITHFORTUNEANDMENSEYESIALLALONEBEWEEPMYOUTCASTSTATE';
      var hash2 = 'ANDTROUBLEDEAFHEAVENWITHMYBOOTLESSCRIESANDLOOKUPONMYSELFANDCURSEMYFATE';
      return this.app.crypto.hash(this.app.crypto.hash(email + pass) + hash1);
    }
  }, {
    key: "returnRetrievalHash",
    value: function returnRetrievalHash() {
      var email = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var pass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var hash1 = 'WHENINDISGRACEWITHFORTUNEANDMENSEYESIALLALONEBEWEEPMYOUTCASTSTATE';
      var hash2 = 'ANDTROUBLEDEAFHEAVENWITHMYBOOTLESSCRIESANDLOOKUPONMYSELFANDCURSEMYFATE';
      return this.app.crypto.hash(this.app.crypto.hash(hash2 + email) + pass);
    }
  }, {
    key: "returnServices",
    value: function returnServices() {
      var services = [];
      if (this.app.BROWSER == 0) {
        services.push(new PeerService(null, 'recovery'));
      }
      return services;
    }
  }, {
    key: "respondTo",
    value: function respondTo(type, obj) {
      if (type == 'saito-header' || type == 'user-menu' && (obj === null || obj === void 0 ? void 0 : obj.publicKey) == this.publicKey) {
        var x = [];
        var unknown_user = this.app.keychain.returnIdentifierByPublicKey(this.publicKey, true) === this.publicKey;
        if (unknown_user) {
          x.push({
            text: 'Login',
            icon: 'fa fa-sign-in',
            rank: 130,
            type: 'utilities',
            callback: function callback(app) {
              app.connection.emit('recovery-login-overlay-render-request');
            }
          });
        } else {
          x.push({
            text: 'Backup',
            icon: 'fa-sharp fa-solid fa-cloud-arrow-up',
            rank: 130,
            type: 'utilities',
            callback: function callback(app) {
              app.connection.emit('recovery-backup-overlay-render-request');
            }
          });
        }
        return x;
      }
      return _superPropGet(Recovery, "respondTo", this, 3)([type]);
    }
  }, {
    key: "onConfirmation",
    value: function () {
      var _onConfirmation = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(blk, tx, conf) {
        var txmsg;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (!(this.app.BROWSER && !tx.isTo(this.publicKey))) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              if (!(Number(conf) == 0)) {
                _context4.n = 3;
                break;
              }
              if (!this.hasSeenTransaction(tx, blk)) {
                _context4.n = 2;
                break;
              }
              return _context4.a(2);
            case 2:
              txmsg = tx.returnMessage();
              if (!(txmsg.request == 'recovery backup')) {
                _context4.n = 3;
                break;
              }
              _context4.n = 3;
              return this.receiveBackupTransaction(tx);
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function onConfirmation(_x5, _x6, _x7) {
        return _onConfirmation.apply(this, arguments);
      }
      return onConfirmation;
    }()
  }, {
    key: "handlePeerTransaction",
    value: function () {
      var _handlePeerTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(app) {
        var tx,
          peer,
          mycallback,
          txmsg,
          _args5 = arguments;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              tx = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : null;
              peer = _args5.length > 2 ? _args5[2] : undefined;
              mycallback = _args5.length > 3 ? _args5[3] : undefined;
              if (!(tx == null)) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2);
            case 1:
              if (!(app.BROWSER == 0)) {
                _context5.n = 2;
                break;
              }
              txmsg = tx.returnMessage();
              if (!((txmsg === null || txmsg === void 0 ? void 0 : txmsg.request) === 'recovery recover')) {
                _context5.n = 2;
                break;
              }
              return _context5.a(2, this.receiveRecoverTransaction(tx, mycallback));
            case 2:
              return _context5.a(2, _superPropGet(Recovery, "handlePeerTransaction", this, 3)([app, tx, peer, mycallback]));
          }
        }, _callee5, this);
      }));
      function handlePeerTransaction(_x8) {
        return _handlePeerTransaction.apply(this, arguments);
      }
      return handlePeerTransaction;
    }() ////////////
    // Backup //
    ////////////
  }, {
    key: "createBackupTransaction",
    value: function () {
      var _createBackupTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(decryption_secret, retrieval_hash) {
        var newtx;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee();
            case 1:
              newtx = _context6.v;
              newtx.msg = {
                module: 'Recovery',
                request: 'recovery backup',
                hash: retrieval_hash,
                wallet: this.app.crypto.aesEncrypt(this.app.wallet.exportWallet(), decryption_secret)
              };
              newtx.addTo(this.publicKey);
              _context6.n = 2;
              return newtx.sign();
            case 2:
              return _context6.a(2, newtx);
          }
        }, _callee6, this);
      }));
      function createBackupTransaction(_x9, _x0) {
        return _createBackupTransaction.apply(this, arguments);
      }
      return createBackupTransaction;
    }()
  }, {
    key: "receiveBackupTransaction",
    value: function () {
      var _receiveBackupTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(tx) {
        var txmsg, publickey, hash, txjson, sql, params, res;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              txmsg = tx.returnMessage();
              publickey = tx.from[0].publicKey;
              hash = txmsg.hash || '';
              txjson = tx.serialize_to_web(this.app);
              console.log('********************');
              console.log('Backup Transaction confirmed on chain');
              console.log('********************');
              sql = 'INSERT OR REPLACE INTO recovery (publickey, hash, tx) VALUES ($publickey, $hash, $tx)';
              params = {
                $publickey: publickey,
                $hash: hash,
                $tx: txjson
              };
              _context7.n = 1;
              return this.app.storage.runDatabase(sql, params, 'recovery');
            case 1:
              res = _context7.v;
              if (this.publicKey === publickey) {
                this.backup_overlay.success();
              }
            case 2:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function receiveBackupTransaction(_x1) {
        return _receiveBackupTransaction.apply(this, arguments);
      }
      return receiveBackupTransaction;
    }()
    /**
     *
     * data = { email, password } or {email, decryption_secret, retrieval_hash }
     *
     */
  }, {
    key: "backupWallet",
    value: function () {
      var _backupWallet = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(data) {
        var email, password, decryption_secret, retrieval_hash, email_text, newtx;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              email = data.email, password = data.password, decryption_secret = data.decryption_secret, retrieval_hash = data.retrieval_hash;
              if (email) {
                _context8.n = 1;
                break;
              }
              console.error('Recovery cannot backup a wallet without an email');
              return _context8.a(2);
            case 1:
              email_text = "This email contains an encrypted backup of your Saito Wallet for \n\t\t\t\t".concat(this.publicKey.substring(0, 6), "...").concat(this.publicKey.slice(-6), ". \n\t\t\t\tThe system should automatically update your backup (and email you again) if you \n\t\t\t\tadd additional keys (adding friends, installing third-party cryptos, etc.). However, \n\t\t\t\twe strongly advise you to regularly back up your account to protect your data");
              if (this.app.options.wallet.backup_required) {
                email_text += "\n\nAutomatically triggered by: ".concat(this.app.options.wallet.backup_required);
              }
              if (!password) {
                _context8.n = 2;
                break;
              }
              //
              // Generate passcode and retreival hash
              //
              decryption_secret = this.returnDecryptionSecret(email, password);
              retrieval_hash = this.returnRetrievalHash(email, password);

              //
              // save email
              //
              this.app.options.wallet.backup_required = false;
              this.app.keychain.addKey(this.publicKey, {
                email: email,
                wallet_decryption_secret: decryption_secret,
                wallet_retrieval_hash: retrieval_hash
              });
              this.app.keychain.saveKeys();
              _context8.n = 3;
              break;
            case 2:
              if (!(!decryption_secret || !retrieval_hash)) {
                _context8.n = 3;
                break;
              }
              console.error('Missing credentials for backup...!');
              return _context8.a(2);
            case 3:
              _context8.n = 4;
              return this.createBackupTransaction(decryption_secret, retrieval_hash);
            case 4:
              newtx = _context8.v;
              _context8.n = 5;
              return this.app.network.propagateTransaction(newtx);
            case 5:
              //
              // Ask mailrelay mod to send us a copy
              //
              this.app.connection.emit('mailrelay-send-email', {
                to: email,
                from: 'Saito Backup <no-reply@saito.tech>',
                subject: 'Saito Wallet - Encrypted Backup',
                text: email_text,
                ishtml: false,
                attachments: [{
                  filename: "saito-wallet-".concat(this.publicKey, ".aes"),
                  content: String(Buffer.from(newtx.msg.wallet, 'utf-8'))
                }]
              });
            case 6:
              return _context8.a(2);
          }
        }, _callee8, this);
      }));
      function backupWallet(_x10) {
        return _backupWallet.apply(this, arguments);
      }
      return backupWallet;
    }() /////////////
    // Recover //
    /////////////
  }, {
    key: "createRecoverTransaction",
    value: function () {
      var _createRecoverTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(retrieval_hash) {
        var newtx;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              _context9.n = 1;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee();
            case 1:
              newtx = _context9.v;
              newtx.msg = {
                module: 'Recovery',
                request: 'recovery recover',
                hash: retrieval_hash
              };
              newtx.addTo(this.publicKey);
              _context9.n = 2;
              return newtx.sign();
            case 2:
              return _context9.a(2, newtx);
          }
        }, _callee9, this);
      }));
      function createRecoverTransaction(_x11) {
        return _createRecoverTransaction.apply(this, arguments);
      }
      return createRecoverTransaction;
    }() //
    // this is never run, see overlay
    //
  }, {
    key: "receiveRecoverTransaction",
    value: function () {
      var _receiveRecoverTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(tx) {
        var mycallback,
          txmsg,
          hash,
          sql,
          params,
          results,
          _args0 = arguments;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              mycallback = _args0.length > 1 && _args0[1] !== undefined ? _args0[1] : null;
              if (!(mycallback == null)) {
                _context0.n = 1;
                break;
              }
              console.warn('No callback');
              return _context0.a(2, 0);
            case 1:
              if (!(this.app.BROWSER == 1)) {
                _context0.n = 2;
                break;
              }
              console.warn("Browsers don't support backup/recovery");
              return _context0.a(2, 0);
            case 2:
              txmsg = tx.returnMessage();
              hash = txmsg.hash || '';
              sql = 'SELECT * FROM recovery WHERE hash = $hash';
              params = {
                $hash: hash
              };
              _context0.n = 3;
              return this.app.storage.queryDatabase(sql, params, 'recovery');
            case 3:
              results = _context0.v;
              console.log('********************');
              console.log('Restore Transaction');
              console.log('********************');
              if (!mycallback) {
                _context0.n = 4;
                break;
              }
              mycallback(results);
              return _context0.a(2, 1);
            case 4:
              console.warn('No callback to process recovered wallet');
            case 5:
              return _context0.a(2, 0);
          }
        }, _callee0, this);
      }));
      function receiveRecoverTransaction(_x12) {
        return _receiveRecoverTransaction.apply(this, arguments);
      }
      return receiveRecoverTransaction;
    }()
  }, {
    key: "restoreWallet",
    value: function () {
      var _restoreWallet = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(email, password) {
        var _this2 = this;
        var decryption_secret, retrieval_hash, newtx, peers, _iterator, _step, peer, _iterator2, _step2, _t;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.p = _context10.n) {
            case 0:
              decryption_secret = this.returnDecryptionSecret(email, password);
              retrieval_hash = this.returnRetrievalHash(email, password);
              _context10.n = 1;
              return this.createRecoverTransaction(retrieval_hash);
            case 1:
              newtx = _context10.v;
              _context10.n = 2;
              return this.app.network.getPeers();
            case 2:
              peers = _context10.v;
              _iterator = _createForOfIteratorHelper(peers);
              _context10.p = 3;
              _iterator.s();
            case 4:
              if ((_step = _iterator.n()).done) {
                _context10.n = 6;
                break;
              }
              peer = _step.value;
              if (peer.services) {
                _iterator2 = _createForOfIteratorHelper(peer.services);
                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    s = _step2.value;
                    console.log(s);
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }
              }
              if (!peer.hasService('recovery')) {
                _context10.n = 5;
                break;
              }
              this.app.network.sendTransactionWithCallback(newtx, /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(rows_as_tx) {
                  var rows, _iterator3, _step3, r, _newtx, txmsg, encrypted_wallet, decrypted_wallet;
                  return _regenerator().w(function (_context1) {
                    while (1) switch (_context1.n) {
                      case 0:
                        console.log('Restoring wallet!!!!!');

                        //This is so weird that the passed data gets turned into a pseudotransaction
                        rows = rows_as_tx.msg;
                        if (rows !== null && rows !== void 0 && rows.length) {
                          _context1.n = 1;
                          break;
                        }
                        console.log('no rows returned!');
                        _this2.login_overlay.failure();
                        return _context1.a(2);
                      case 1:
                        if (rows[0].tx) {
                          _context1.n = 2;
                          break;
                        }
                        console.log('no transaction in row returned');
                        _this2.login_overlay.failure();
                        return _context1.a(2);
                      case 2:
                        // Decrypt wallet(s) here
                        _iterator3 = _createForOfIteratorHelper(rows);
                        try {
                          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                            r = _step3.value;
                            _newtx = new Transaction();
                            _newtx.deserialize_from_web(_this2.app, r.tx);
                            txmsg = _newtx.returnMessage();
                            console.log('decrypting recovered wallet...');
                            encrypted_wallet = txmsg.wallet;
                            decrypted_wallet = _this2.app.crypto.aesDecrypt(encrypted_wallet, decryption_secret);
                            r.decrypted_wallet = decrypted_wallet;
                          }
                        } catch (err) {
                          _iterator3.e(err);
                        } finally {
                          _iterator3.f();
                        }
                        _this2.login_overlay.selection(rows);
                      case 3:
                        return _context1.a(2);
                    }
                  }, _callee1);
                }));
                return function (_x15) {
                  return _ref2.apply(this, arguments);
                };
              }(), peer.publicKey);
              return _context10.a(2);
            case 5:
              _context10.n = 4;
              break;
            case 6:
              _context10.n = 8;
              break;
            case 7:
              _context10.p = 7;
              _t = _context10.v;
              _iterator.e(_t);
            case 8:
              _context10.p = 8;
              _iterator.f();
              return _context10.f(8);
            case 9:
              if (document.querySelector('.saito-overlay-form-text')) {
                document.querySelector('.saito-overlay-form-text').innerHTML = '<center>Unable to download encrypted wallet from network...</center>';
              }
            case 10:
              return _context10.a(2);
          }
        }, _callee10, this, [[3, 7, 8, 9]]);
      }));
      function restoreWallet(_x13, _x14) {
        return _restoreWallet.apply(this, arguments);
      }
      return restoreWallet;
    }()
  }]);
}(ModTemplate);
module.exports = Recovery;